import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { SegmentoSaudeComponent } from './segmento-saude.component';
import { CabecalhoEsquerdaModule } from '../../components/cabecalho/cabecalho-esquerda/cabecalho-esquerda.module';
import { SolucoesModule } from '../../components/solucoes/solucoes.module';
import { ExemplosModule } from '../../components/exemplos/exemplos.module';

@NgModule({
  declarations: [
    SegmentoSaudeComponent
  ],
  imports: [
    TranslateModule,
    CommonModule,
    CabecalhoEsquerdaModule,
    SolucoesModule,
    ExemplosModule
  ],
  exports: [
    SegmentoSaudeComponent
  ]
})

export class SegmentoSaudeModule { }
